import React from 'react';
import { Form } from 'semantic-grab-ui';
import { Checkbox, Col, Row } from 'grab-ui';
import { LIMIT_ITEMS } from 'omega-rtc/constants/ucd';
import FormInputWithError from 'omega/components/form/FormInputWithError';
import { TridentCampaignFormData } from 'omega-rtc/types/ucd/campaign';
import _ from 'lodash';


type Props = {
  formData: TridentCampaignFormData,
  handleInputChange: Function,
  errors: Array<string>
};


export class LimitSection extends React.Component {
  props: Props;

  constructor(props: Props) {
    super(props);
    this.state = {
      showLimitForm: false,
    };
  }

  handleInputChange = (event: any, { name, value }: { name: string, value: string }) => {
    if (value === '') {
      value = 0;
    }
    if (!Number.isInteger(parseInt(value, 10))) {
      // If the value is not an integer, don't allow it to be set.
      return;
    }
    this.props.handleInputChange(event, { name, value });
  };

  render() {
    const { formData, errors } = this.props;
    const limitForm = _.get(formData, 'limit', {});
    return (
      <Row className={'sub-section-row form-row'}>
        <h3>Action Limit</h3>
        {!_.isEmpty(limitForm) || this.state.showLimitForm ?
          <div className={'panel'}>
            {!_.isEmpty(errors) &&
              <div className="ui negative message">
                <div className="header"><span className="validation-icon" />
                  {_.map(errors, (error) => <p>{error}</p>)}
                </div>
              </div>
            }
            <Row>
              {_.map(LIMIT_ITEMS, limitItem => {
                const isUnlimited = _.get(formData, limitItem.checkboxKey, false);
                return (<Col span={12} key={limitItem.inputKey}>
                  <FormInputWithError
                    key={limitItem.inputKey}
                    name={limitItem.inputKey}
                    {...this.props}
                  >
                    <label>{limitItem.label}  <span className={'red-asterisk'}>*</span></label>
                    <Form.Input
                      required
                      disabled={isUnlimited}
                      type="number"
                      value={_.get(formData, limitItem.inputKey, 0)}
                      onChange={this.handleInputChange}
                    />
                    <Checkbox
                      checked={isUnlimited}
                      onChange={e => {
                        this.props.handleInputChange(e.event, { name: limitItem.checkboxKey, value: e.target.checked });
                        this.props.handleInputChange(e.event, { name: limitItem.inputKey, value: 0 }); // set input value to 0
                      }}
                      style={{ width: '100%', marginTop: '5px', fontWeight: '400' }}
                    >
                      Unlimited
                    </Checkbox>
                  </FormInputWithError>
                </Col>);
              })
              }
            </Row>
          </div>
          : <button className="rule-menu" onClick={() => this.setState({ showLimitForm: true })}>Add Limit</button>
        }
      </Row>
    );
  }
}

export default LimitSection;
